module.exports = __webpack_public_path__ + "static/media/redes_icons-02.1e4adee6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/redes_icons-02.png
// module id = 146
// module chunks = 0